import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Gauge, BarChart3, CalendarClock, LayoutDashboard, MonitorCheck, Sparkles, Bot } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';

const menuItems = [
  {
    id: 'eficiencia',
    title: 'Reporte 360 / Eficiencia',
    description: 'Análisis operacional detallado de un centro de lavado por rango de fechas',
    icon: <Gauge className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />,
    path: '/dashboard/eficiencia',
    iconBg: 'bg-indigo-500/15',
    borderColor: 'hover:border-indigo-500/50',
    color: 'bg-indigo-500/10',
  },
  {
    id: 'eficiencia-v2',
    title: 'Reportes específicos',
    description: 'Reportes de eficiencia, productividad y comparativos entre centros de lavado',
    icon: <Sparkles className="h-8 w-8 text-amber-600 dark:text-amber-400" />,
    path: '/dashboard/reportes-360',
    iconBg: 'bg-amber-500/15',
    borderColor: 'hover:border-amber-500/50',
    color: 'bg-amber-500/10',

  },
  {
    id: 'comparativo',
    title: 'OKR — Objetivos y Resultados Clave',
    description: 'Resultados clave por mes y en relación a los kilos, comparando uno o varios centros',
    icon: <BarChart3 className="h-8 w-8 text-violet-600 dark:text-violet-400" />,
    path: '/dashboard/comparativo',
    iconBg: 'bg-violet-500/15',
    borderColor: 'hover:border-violet-500/50',
    color: 'bg-violet-500/10',
  },
/*   {
    id: 'agentes',
    title: 'Agentes IA',
    description: 'Personalidad y funciones de los agentes, objetivos del mes, indicaciones y metas de los centros',
    icon: <Bot className="h-8 w-8 text-sky-600 dark:text-sky-400" />,
    path: '/dashboard/agentes',
    iconBg: 'bg-sky-500/15',
    borderColor: 'hover:border-sky-500/50',
    color: 'bg-sky-500/10',
    badge: 'NUEVO',
  }, */
  {
    id: 'cortes',
    title: 'Gestión de Cortes Mensuales',
    description: 'Genera, elimina y regenera el consolidado mensual de cada centro',
    icon: <CalendarClock className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />,
    path: '/dashboard/cortes',
    iconBg: 'bg-emerald-500/15',
    borderColor: 'hover:border-emerald-500/50',
    color: 'bg-emerald-500/10',
  },
/*   {
    id: 'monitoreo',
    title: 'Centro de Monitoreo',
    description: 'Completitud de registros, métricas fuera de parámetro y notificaciones de todos los centros',
    icon: <MonitorCheck className="h-8 w-8 text-sky-600 dark:text-sky-400" />,
    path: '/monitor-registros',
    iconBg: 'bg-sky-500/15',
    borderColor: 'hover:border-sky-500/50',
    color: 'bg-sky-500/10',
  }, */
];

const DashboardHomePage = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="p-4 md:p-4 lg:p-4"
    >
      <Card>
        <CardHeader className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-b border-border/50">
          <div className="flex items-center gap-4">
            <div className="bg-indigo-500/15 p-2.5 rounded-lg">
              <LayoutDashboard className="h-7 w-7 text-indigo-600 dark:text-indigo-400" />
            </div>
            <div>
              <CardTitle className="text-2xl">Dashboard</CardTitle>
              <CardDescription className="mt-1">
                Reportes operacionales, comparativos entre centros y gestión de consolidados
              </CardDescription>
            </div>
          </div>
        </CardHeader>

        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {menuItems.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.08 }}
                onClick={() => navigate(item.path)}
                className={`${item.color} p-6 rounded-lg border border-border shadow-sm transition-all duration-200 cursor-pointer hover:shadow-md ${item.borderColor} relative`}
              >
                {item.badge && (
                  <span className="absolute top-3 right-3 text-[9px] font-bold tracking-wider px-2 py-0.5 rounded-full bg-amber-500 text-white">
                    {item.badge}
                  </span>
                )}
                <div className="flex flex-col items-center text-center">
                  <div className={`p-2.5 rounded-lg ${item.iconBg}`}>
                    {item.icon}
                  </div>
                  <h3 className="text-base font-semibold mt-3">{item.title}</h3>
                  <p className="text-xs text-muted-foreground mt-1.5 line-clamp-2">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default DashboardHomePage;
